import React from 'react'
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { useSelector } from 'react-redux';
import { makeStyles, Typography } from '@material-ui/core';
import { grey600, grey800 } from 'material-ui/styles/colors';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom:'25px',
    '& .MuiStepIcon-completed': {
      color: theme.palette.eSecondary.base,
    },
    '& .MuiStepIcon-active': {
      color: theme.palette.ePrimary.base,
    },
    "& .MuiStepConnector-lineHorizontal": {
      marginTop: 7,
      marginLeft: 10,
      marginRight: 10
    },
    "& .MuiStepIcon-text": {
      fill: grey800
    },
    "& .MuiStepIcon-active .MuiStepIcon-text": {
      fill: "white"
    },
    "& .MuiStepIcon-completed .MuiStepIcon-text": {
      fill: "white"
    },
    "& .MuiStepLabel-label.MuiStepLabel-completed": {
      color: grey600
    },
    [theme.breakpoints.down("sm")]: {
      padding:"0px !important"
    },
    
  },
  stepLabel: {
    border: 10,
    position:'relative',
    fontSize: "2rem",
    "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
      marginTop: 6,
      width:100
    },
    "& .MuiStepLabel-active": {
      color: theme.palette.ePrimary.base,
    },
    "& .MuiSvgIcon-root": {
      fontSize: 40
    },
  },
  stepLabelFont: {
    fontSize: "large"
  },
  stepText:{
    position:'absolute',
    top:'50%',
    left:'50%',
    transform:'translate(-50%,50%)' 
  }
}))

function EStepper(props) {
  const { activeStep } = props
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.APPLICANT_DETAILS);
  const applicantLabels = useSelector((state) => state?.labels?.data?.getLabels?.E_APPLICANT_DETAILS);
  const classes = useStyles();
  const { t: premiseLabel, ready: labelReady } = useTranslation("label-E_PREMISE_DETAILS");
  const getSteps = () => {
    return [
      labels?.APPLICANT_DETAILS,
      premiseLabel("E_PREMISE_COMMUNICATION_DETAILS"),
      applicantLabels?.E_APPLICANT_UPLOAD_DOCUMENTS,
    ];
  }
  const steps = getSteps();
  return (
      <Stepper activeStep={activeStep} alternativeLabel className={classes.root}>
        {steps.map((label, index) =>
          <Step key={label}>
            <StepLabel   className={classes.stepLabel}>
              <Typography   variant="subtitle1" className={classes.stepText}>
              {
                labelReady?
                <b>{label}</b>
                : ''
              }
              </Typography>
            </StepLabel>
          </Step>
        )}
      </Stepper>
  )
}

export default EStepper;